import React, { Component } from 'react';
import { Table, Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
import NewElement from './NewElement';
import Scoring from './Scoring';
export default class ViewTemplate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      additionalField:[],
      nameExist:false,
      toggleI:true,
      toggleT:false
    }
    this.rows={'Parameters':[], 'Additional':[]}
  }
  
  componentDidMount() {
    const{templatepayload} = this.props;
    this.createTemplate(_.cloneDeep(templatepayload.templateValue.Parameters))
   
    if(!_.isEmpty(templatepayload.templateValue.Additional)){
      this.setState({additional:true})
      this.setState({additionalField:templatepayload.templateValue.Additional})
    }
  }
  
    NewRenderCallbackFunction(row) {
    let last = _.find(this.state.templateObj, {'key':row.key});
    let lastid = last.Parameters.value.id;
    if(_.isEqual(row.Parameters.value.label, last.Parameters.value.label)){
        row.Parameters.value.id = lastid; 
    } else {
      row.Parameters.value.id = lastid+1; 
    }
  }
  CallbackFunction(row) {
  }  
  createTemplate = (json) => { 
    const{dataList} = this.props
    let prop = 'Addtional Fields'
   // let isparamVisited = false
   // let isAttribVisited = false
    let templateObj = [];
    let payload = [];
    payload["Parameters"] = dataList.Parameters;
    payload["Attributes"] = dataList.Attributes;
    payload["Questions"] = dataList.Questions;
    payload["Additional"] = dataList[prop];
    payload["Scoring"] = dataList;
    _.map(json, (obj, paramindex) => {   
       // isparamVisited = true   
      _.map(obj.attributes, (val, index) => {
       //   isAttribVisited = true
        _.map(val.questions, (next, questindex) => {
          _.map(next.Scoring, (tt, scoreindex) => {
            let tempTemplateObj = {};
            // let isParamDisable = ((isparamVisited === false) || (isAttribVisited === false)) ? true : false;
            // let isAttribDisable = (isAttribVisited === false) ? true : false;
            tempTemplateObj.key = 'K' + templateObj.length
            tempTemplateObj.Parameters = {};
            tempTemplateObj.Parameters.id = "Parameters";
            tempTemplateObj.Parameters.value = obj;
            //tempTemplateObj.Parameters.disabled = isParamDisable;
            tempTemplateObj.Attributes = {};
            tempTemplateObj.Attributes.id = "Attributes";
            tempTemplateObj.Attributes.value = val;
            //tempTemplateObj.Attributes.disabled = isAttribDisable;
            tempTemplateObj.Questions = {};
            tempTemplateObj.Questions.id = "Questions";
            tempTemplateObj.Questions.value = next;
            tempTemplateObj.Scoring = {};
            tempTemplateObj.Scoring.id = "Scoring";
            tempTemplateObj.Scoring.value = tt;
            templateObj.push(tempTemplateObj);
          });
         // isparamVisited = false
          //isAttribVisited = false
        });
      });
    });
    this.setState({ templateObj, payload });
  }
  CallbackFunctionScoring = (rowIndex, obj) =>{
    const {templateObj} = this.state;
    templateObj[rowIndex].Scoring.value = obj
    this.setState({templateObj})
  }
 
  renderBody = () => {
    const {templateObj, payload} = this.state;
    if(templateObj && templateObj.length > 0) {
      return _.map(templateObj, (row, rowIndex) => {
        return (
          <tr className='FormTemplate' key={row.key}>
            <td><NewElement Callback={this.CallbackFunction} row={row} value={row.Parameters.value} payload={payload.Parameters} disabled={row.Parameters.disabled}
              id={row.Parameters.id} /></td>
            <td><NewElement Callback={this.CallbackFunction} row={row} value={row.Attributes.value} payload={payload.Attributes} disabled={row.Attributes.disabled}
              id={row.Attributes.id} /></td>
            <td><NewElement Callback={()=>this.NewRenderCallbackFunction(row)} value={row.Questions.value} payload={payload.Questions}
              id={row.Questions.id} /></td>
            <td><Scoring CallbackFunctionScoring={this.CallbackFunctionScoring} index={rowIndex} value={row.Scoring.value} payload={payload.Scoring}
              id={row.Scoring.id} /></td>
             <td></td> 
          </tr>
        )
      });
    }
    return (
      <tr className=""><td colSpan="5">No Records found.</td></tr>
    );
  }
  additionalFields = (e) => {    
    this.setState({additional:e.target.checked})
  }
  createNewField = (obj, e) => {
    let additionalFields = this.state.additionalField 
    let xIndex = _.findIndex(additionalFields, obj)
    if(e.target.checked){
      let x = _.find(additionalFields, obj);      
      if(_.isEmpty(x)){
        additionalFields.push(obj)
      }
    } else {
      _.pullAt(additionalFields, xIndex)
    }
    this.setState({additionalField:additionalFields})    
  }
  handleAdditionalBody = () => {
    const {payload, additional} = this.state;
    const{templatepayload} = this.props;
    let firstcol=[], secondCol=[], thirdcol=[];
    if(additional){
      _.map(payload.Additional, (obj, i)=> {        
        if(obj.label === 'Drop Down'){
          //let selDrop = _.find(templatepayload.templateValue.Additional, {'labelObj':obj.labelObj})
          let selDrop = _.find(templatepayload.templateValue.Additional, {'id':obj.id})
          let options = []
          _.map(obj.additionalValues, (obj1) =>{
            if(obj1['status']  !== 'INACTIVE'){
              options.push(obj1)
            }
          })
          firstcol.push(    
         <Col md={3} className='marginBottom'>&nbsp; 
         <input type='CheckBox' checked={!_.isEmpty(selDrop) ? selDrop  : null} 
            onChange={(e)=>this.createNewField(obj,e)}/>&nbsp;<b>{obj.labelObj}</b>
            <Picky keepOpen={false}
            value={[]}
            options={options}
            open={false}
            valueKey="label"
            labelKey="label"
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select'
            dropdownHeight={600}
            />     
         </Col>
         ) }
        if(obj.label === 'Text Area'){
          let seltext = _.find(templatepayload.templateValue.Additional, {'id':obj.id})
          secondCol.push(    
            <Col md={3} className='marginBottom template'>&nbsp;  
           <input type='CheckBox' checked={!_.isEmpty(seltext) ? seltext  : null} 
           onChange={(e)=>this.createNewField(obj,e)}/>&nbsp;<b>{obj.labelObj}</b><br/>                 
           </Col>
           ) 
        }
        if(obj.label === 'Text Box'){
          let selArea = _.find(templatepayload.templateValue.Additional, {'id':obj.id})
          thirdcol.push(    
            <Col md={3} className='marginBottom '>&nbsp; 
           <input type='CheckBox' checked={!_.isEmpty(selArea) ? selArea  : null} 
           onChange={(e)=>this.createNewField(obj,e)}/>&nbsp;<b>{obj.labelObj}</b>          
           </Col>
           ) 
        }        
        }) 
        return  (<div className='aditionalModification' style={{'pointerEvents':'none'}}>  
          <span><b>Drop Down</b></span>
         <hr/>       
         <Row>{firstcol}</Row>
         <span><b>Text Area</b></span>
         <hr/>
         <Row>{secondCol}</Row>
         <span><b>Text Box</b></span>
         <hr/>
         <Row>{thirdcol}</Row>
        
         </div>)
    } 
  }
  handleTemplate  = () =>{
    this.setState((prevState) =>{
      return {toggleI: !prevState.toggleI};
    })
  }
  
  handleadditionalInformation = () =>{
    this.setState((prevState) =>{
      return {toggleT: !prevState.toggleT};
    })
  } 
  
  render() {
    const{additional, toggleI, toggleT} = this.state;
    return (
         <div >
           <span className='alignRight RedColoring'>NC reasons cannot be viewed from this page</span>
           <h6 className={toggleI ? 'evalFormMargin': 'evalForm'} onClick={this.handleTemplate}>
          {toggleI ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b>
              ASSESMENT TEMPLATE</b> </h6>
          <div className={toggleI ? 'assesmentShow': 'assesmentHide'}>       
            <Table responsive style={{'pointerEvents':'none'}}>
              <thead>
                <tr>
                  <th>PARAMETERS<span className="RedColoring"> *</span></th>
                  <th>ATTRIBUTES<span className="RedColoring"> *</span></th>
                  <th>QUESTIONS<span className="RedColoring"> *</span></th>
                  <th>SCORING ENTITY</th>   
                  <th style={{'padding':'0px'}}></th>               
                </tr>
              </thead>
              <tbody>
                {
                  this.renderBody()
                }
              </tbody>
            </Table>
            </div>
            <div className='clearBoth'>            
              <h6 className={toggleT ? 'evalFormMargin': 'evalForm'} onClick={this.handleadditionalInformation}>
              {toggleT ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b>&nbsp;
              <input disabled={true} type='Checkbox' checked={additional} onChange={this.additionalFields}/>&nbsp;
              ADDITIONAL INFORMATION</b></h6>
              <div className={toggleT ? 'assesmentShow': 'assesmentHide'}>  
              { this.handleAdditionalBody() }
              </div>
            </div>           
          </div>
    )
  }
};